/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Metrics_Chart_SubtitleInputs */

const en_ui_metrics_chart_subtitle = /** @type {(inputs: Ui_Metrics_Chart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Long-term fitness, fatigue, and readiness trends`)
};

const de_ui_metrics_chart_subtitle = /** @type {(inputs: Ui_Metrics_Chart_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langfristige Fitness-, Ermüdungs- und Bereitschaftstrends`)
};

/**
* | output |
* | --- |
* | "Long-term fitness, fatigue, and readiness trends" |
*
* @param {Ui_Metrics_Chart_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_metrics_chart_subtitle = /** @type {((inputs?: Ui_Metrics_Chart_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Metrics_Chart_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_metrics_chart_subtitle(inputs)
	return de_ui_metrics_chart_subtitle(inputs)
});